// External dependencies
import { useNavigate, useRouterState } from "@tanstack/react-router";
import {
  HelpCircle,
  LogOut,
  Settings,
} from "lucide-react";

// Internal components
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { authStore } from "@/providers/authStore";

/**
 * NavUser Component
 *
 * User profile section in the dashboard sidebar footer.
 * Displays user information and provides a dropdown with user-related actions.
 *
 * @param {Object} props - Component props
 * @param {Object} props.user - User information
 * @param {string} props.user.name - User's name
 * @param {string} props.user.email - User's email
 * @param {string} props.user.avatar - URL to user's avatar image
 */
export function NavFooter() {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  // Define footer items with their URLs
  const footerItems = [
    {
      label: "Settings",
      icon: Settings,
      url: "branch/settings/",
      onClick: () => {    navigate({ to: "/company/settings" }); },
    },
    {
      label: "Help and first steps",
      icon: HelpCircle,
      url: "/help",
      onClick: () => {},
    },
    {
      label: "Logout",
      icon: LogOut,
      url: "/login",
      onClick: () => {
        localStorage.clear();
        authStore.clear();
        navigate({ to: "/login" });
      },
    },
  ];
  return (
    <SidebarMenu>
      {footerItems.map((item) => {
        const isActive = pathname === item.url || pathname.startsWith(item.url + "/");
        return (
          <SidebarMenuItem key={item.label}>
            <SidebarMenuButton isActive={isActive} aria-label={item.label} onClick={item.onClick}>
              <item.icon aria-hidden="true" />
              <span>{item.label}</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        );
      })}
    </SidebarMenu>
  );
}